/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Authorized_Apps_Confirm_MsgInputs */



/**
* | output |
* | --- |
* | "{name} will no longer be able to access your account. You'll need to authorize it again next time you sign in." |
*
* @param {Authorized_Apps_Confirm_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const authorized_apps_confirm_msg = /** @type {((inputs: Authorized_Apps_Confirm_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authorized_Apps_Confirm_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} ne pourra plus accéder à votre compte. Vous devrez l'autoriser à nouveau la prochaine fois que vous vous connecterez.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} ya no podrá acceder a su cuenta. Deberá autorizarla de nuevo la próxima vez que inicie sesión.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} não poderá mais acessar sua conta. Você precisará autorizá-lo novamente na próxima vez que fizer login.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} non potrà più accedere al suo account. Dovrà autorizzarla nuovamente al prossimo accesso.`)
	return /** @type {LocalizedString} */ (`${i?.name} will no longer be able to access your account. You'll need to authorize it again next time you sign in.`)
});